module.exports = __webpack_public_path__ + "img/Avatar-15.4f08908b.svg";